import { Box, LinearProgress, Typography } from '@mui/material';
import * as React from 'react';

interface ProgressBarProps {
  answeredCount: number;
  totalQuestions: number;
  progressPercentage: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  answeredCount,
  totalQuestions,
  progressPercentage,
}) => {
  return (
    <Box sx={{ mb: 2, maxWidth: 1150, mx: 'auto', pt: 3 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mb: 1,
        }}
      >
        <Typography
          sx={{
            color: '#000',
            fontFamily: 'Roboto-Regular !important',
            fontSize: '9.5pt !important',
          }}
        >
          Progress: {answeredCount} of {totalQuestions} answered
        </Typography>

        <Typography
          sx={{
            color: '#000',
            fontFamily: 'Roboto-Bold !important',
            fontSize: '9.5pt !important',
          }}
        >
          {Math.round(progressPercentage)}%
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={progressPercentage}
        sx={{
          height: 8,
          borderRadius: '4px',
          backgroundColor: 'rgba(16, 185, 129, 0.2)',
          '& .MuiLinearProgress-bar': {
            borderRadius: '4px',
            background: '#10b981',
          },
        }}
      />
    </Box>
  );
};
